import cx from "classnames";
import { gql, useQuery } from "utils/urql";
import { HomepageLedeQuery } from "types/api";
import Image from "components/Image";
import Authors from "components/Authors";
import styles from "./Lede.module.scss";
import Caption from "./Caption";

const query = gql`
  query HomepageLede {
    homepageModule(slug: "lede", version: "b1") {
      ... on HomepagePromoItem {
        __typename
        id
        url
        title
        dek
        kicker
        kickerUrl
        authors {
          id
          url
          displayName
        }
        riverImage(
          width: 624
          height: 351
          sizes: [
            "543w"
            "569w"
            "615w"
            "624w"
            "1086w"
            "1138w"
            "1230w"
            "1248w"
          ]
        ) {
          url
          srcSet
          width
          height
          altText
          attributionText
          attributionUrl
        }
      }
    }
  }
`;

const Lede = () => {
  const [{ data }] = useQuery<HomepageLedeQuery>({ query });

  if (!data || data.homepageModule?.__typename !== "HomepagePromoItem")
    return null;

  const article = data.homepageModule;

  return (
    <article className={styles.root}>
      {article.riverImage && (
        <figure className={styles.figure}>
          <a data-action="click link - lede - image" href={article.url}>
            <Image
              lazy={false}
              src={article.riverImage.url}
              srcSet={article.riverImage.srcSet}
              width={article.riverImage.width}
              height={article.riverImage.height}
              alt={article.riverImage.altText}
              preload={true}
              sizes="(min-width: 1296px) 624px, (min-width: 976px) calc(50vw - 32px), (min-width: 576px) calc(62vw - 32px), calc(100vw - 32px)"
            />
          </a>

          <Caption
            attributionText={article.riverImage.attributionText}
            attributionUrl={article.riverImage.attributionUrl}
          />
        </figure>
      )}

      {article.kicker &&
        (article.kickerUrl ? (
          <a className={styles.kicker} href={article.kickerUrl}>
            {article.kicker}
          </a>
        ) : (
          <div className={styles.kicker}>{article.kicker}</div>
        ))}

      <h1
        className={cx(styles.title, article.kicker && styles.titleWithKicker)}
      >
        <a
          className={styles.titleLink}
          dangerouslySetInnerHTML={{ __html: article.title }}
          data-action="click link - lede - title"
          href={article.url}
        ></a>
      </h1>

      {article.dek && (
        <p
          className={styles.dek}
          dangerouslySetInnerHTML={{ __html: article.dek }}
        ></p>
      )}

      {article.authors.length > 0 && (
        <div className={styles.byline}>
          <Authors
            authors={article.authors}
            component={({ url, displayName }) => (
              <a
                href={url}
                className={styles.authorLink}
                data-action="click link - lede - author"
              >
                {displayName}
              </a>
            )}
          />
        </div>
      )}
    </article>
  );
};

export default Lede;
